export const userPermissionsEnum = {
    OPU: 'OPU',
    User: 'User',
    Full: 'Full',
    View: 'View',
};
